/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { FlexContainer } from "@nordcloud/gnui";
import { StepCounter, StepWrapper } from "./styles";

type Props = {
  counter: number;
  children: React.ReactNode;
};

export function StepContainer({ counter, children }: Props) {
  return (
    <FlexContainer alignItems="flex-start">
      <StepCounter>{counter}</StepCounter>
      <StepWrapper>{children}</StepWrapper>
    </FlexContainer>
  );
}
